module.exports = __webpack_public_path__ + "static/media/A18040103_10004_6.6b36a2be.jpg";